import { Select } from 'antd';
import { IBasicField, IRegion, IState } from 'src/shared/models';

export const addressField: IBasicField[] = [
  {
    disabled: false,
    id: 'firstname',
    name: 'form.address.name',
    type: 'string',
    required: true,
  },
  {
    disabled: false,
    id: 'middlename',
    name: 'form.address.middlename',
    type: 'string',
    required: true,
  },
  {
    disabled: false,
    id: 'lastname',
    name: 'form.address.lastname',
    type: 'string',
    required: true,
  },
  {
    disabled: false,
    id: 'street',
    name: 'form.address.address',
    type: 'string',
    required: true,
    array: [
      {
        append: 'name',
        disabled: false,
        id: 'street',
        name: 'form.address.street-name',
        position: 0,
        type: 'string',
        required: true,
      },
      {
        append: 'number',
        disabled: false,
        id: 'street',
        name: 'form.address.street-number',
        position: 1,
        type: 'number',
        required: true,
      },
    ],
  },
  {
    disabled: false,
    id: 'postcode',
    name: 'form.address.zipcode',
    type: 'number',
    required: true,
  },
  {
    disabled: false,
    id: 'city',
    name: 'form.address.city',
    type: 'string',
    required: true,
  },
  {
    disabled: false,
    id: 'region_id',
    name: 'form.address.state',
    type: 'string',
    isCombo: true,
    required: true,
  },
  {
    disabled: false,
    id: 'telephone',
    name: 'form.address.phone',
    type: 'number',
    required: true,
    placeholder: 'form.address.phone-placeholder',
    isPhone: true,
  },
  {
    disabled: false,
    id: 'default_billing',
    name: 'form.address.default-billing',
    type: 'boolean',
    required: false,
  },
  {
    disabled: false,
    id: 'default_shipping',
    name: 'form.address.default-shipping',
    type: 'boolean',
    required: false,
  },
];

export const renderCombo = (stateList: IState, handleEditInput?: Function) => {
  let countries: IRegion[] = [];
  if (stateList) countries = stateList.available_regions;

  return (
    <Select
      onChange={(value, option: any) =>
        handleEditInput && handleEditInput('state', option.value)
      }
    >
      {countries.map((element: IRegion) => (
        <Select.Option key={element.id} value={element.id}>
          {element.name}
        </Select.Option>
      ))}
    </Select>
  );
};
